webpackJsonpUpdateBris([96],{

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'FeaturePanelWidthHalf';
var CLS = 'featurePanelWidthHalf';
var BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


var FeaturePanelWidthHalf = exports.FeaturePanelWidthHalf = function () {
	function FeaturePanelWidthHalf($el) {
		_classCallCheck(this, FeaturePanelWidthHalf);

		// $el is the blk node return by the loadFeaturePanelWidthHalf function
		this.$el = $el;
	}

	_createClass(FeaturePanelWidthHalf, [{
		key: 'init',
		value: function init() {
			this.setFeaturePanelWidthHalf();
		}
	}, {
		key: 'setFeaturePanelWidthHalf',
		value: function setFeaturePanelWidthHalf() {
			// Add Some logic here
			var $featurePanel = $(this.$el);
			setTimeout(function () {
				var $btnlist = $featurePanel.find('.featurePanel-ctaWrap .button-btn');
				if ($btnlist.length > 1) {
					var widthLongest = 0;
					$btnlist.each(function (index, el) {
						var width = $(el).innerWidth() + 2;
						if (width > widthLongest) widthLongest = width;
					});
					$btnlist.each(function (index, el) {
						$(el).css('width', widthLongest + 'px');
					});
				}
			}, 200);
		}

		// Add more functions like on above here

	}]);

	return FeaturePanelWidthHalf;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.blk-feature-panel-width-half-chunk.js